import { ShopInternalInventoryDetails } from 'containers/shop';
import { FC } from 'react';

const ShopInternalInventoryDetailsPage: FC = () => {
  return <ShopInternalInventoryDetails />;
};

export default ShopInternalInventoryDetailsPage;
